import { Table } from "@/features/Table";
import {
  type A5DerivativeBarriers,
  derivative_barriers_columns,
} from "./columns";
import {
  type FilterA5DerivativeBarriersSchema,
  FilterA5DerivativeBarriers,
} from "./filter";
import { useTranslation } from "react-i18next";

const client = "a5";
const table_name = "a5_derivative_barriers";

export const A5DerivativeBarriersTable = () => {
  const { t } = useTranslation();

  return (
    <Table<A5DerivativeBarriers, FilterA5DerivativeBarriersSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Structured product barriers",
      })}
      client={client}
      table_name={table_name}
      columns={derivative_barriers_columns}
      filter={<FilterA5DerivativeBarriers />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
